<template>
  <v-main>
    <the-toolbar></the-toolbar>
    <the-sidebar></the-sidebar>

      <router-view/>

  </v-main>
</template>

<script>
import TheSidebar from "../components/SideBar/theSidebar";
import TheToolbar from "../components/ToolBar/theToolbar";

export default {
  components: {TheToolbar, TheSidebar},

};
</script>

<style>
.v-content__wrap {
  height: 100%;
}
</style>
